export const shortenWalletAddress = (address: string): string => {
  const firshPart = address.slice(0, 5);
  const lastPart = address.slice(-4);
  return `${firshPart}...${lastPart}`;
};
